// src/SignIn.js
import React from 'react';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import app from './firebase'; // Asegúrate de que la ruta sea correcta

const SignIn = () => {
  const signInWithGoogle = () => {
    const auth = getAuth(app);
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        // Esto te da un token de acceso de Google. Puedes usarlo para acceder a la API de Google.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // La información del usuario autenticado
        const user = result.user;
        //console.log(user);
      }).catch((error) => {
        // Manejo de errores aquí
        const errorCode = error.code;
        const errorMessage = error.message;
        // El correo electrónico de la cuenta del usuario que fue usado para intentar iniciar sesión.
        const email = error.email;
        // El tipo de AuthCredential que se usó.
        const credential = GoogleAuthProvider.credentialFromError(error);
        //console.error(errorMessage);
      });
  };

  return (
    <button className="btn-login" onClick={signInWithGoogle}>Ingresar</button>
  );
};

export default SignIn;
